import React from 'react';
import ErrorBoundary from '@Components/ErrorBoundary';

export default function withErrorBoundary(Component) {
  return function WrappedComponent(props) {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
}
